import { t } from 'i18next';
import * as Yup from 'yup';

export const buildValidationSchema = (fields) =>
    Yup.object().shape(
      fields.reduce((acc, field) => {
        let validator = Yup.number().typeError(t('companyEdit.errorMessages.name'));
        if (field.required) {
          validator = validator.required(t('companyEdit.errorMessages.name'));
        }
        acc[field.name] = validator;
        return acc;
      }, {})
    );
  